import React, { useEffect } from 'react';
import { Route } from 'react-router';
import { useLocation, Redirect, Switch } from 'react-router-dom';
 
import { Home } from './components/Home';
import { Error } from './components/Error';
import { Privacy } from './components/Privacy';
import { VerifyEmail } from './components/VerifyEmail';
import { ResetPassword } from './components/ResetPassword';
import { NotFound } from './components/NotFound';
import { Auction } from './components/auction/Auction';
import { Lot } from './components/auction/Lot';
//import  Stripe from './components/Stripe';
import { Layout } from './components/Layout';
import { Seller } from './components/Seller';
import { Director } from './components/Director';
import { Search } from './components/Search';

import 'react-toastify/dist/ReactToastify.css';
import './sass/styles.scss';
import { AppDataContextProvider } from "./components/AppDataContext"

import { Favorites, BiddingHistoryLayout } from './components/account/Favorites';
import { DashboardLayout } from './components/account/DashboardLayout';
import { Auctioneers } from './components/account/Auctioneers';
import { Searches } from './components/account/Searches';
import { AccountLayout } from './components/account/AccountLayout';
import { Dashboard } from './components/account/Dashboard';
import { PersonalInfo } from './components/account/PersonalInfo';
import { Invoices } from './components/account/Invoices';
import { Invoice } from './components/account/Invoice';
import { Notifications } from './components/account/Notifications';
import { Payment } from './components/account/Payment';
import { Helmet } from "react-helmet";
import { TaxCerts } from './components/account/TaxCerts';
import { Logout } from './components/account/Logout';
import { Sell } from './components/Sell';
import { About } from './components/About';
import { Terms } from './components/Terms';
import { Contact } from './components/Contact';
import { FAQ } from './components/FAQ';
import ReactGA from 'react-ga4';

// don't fire up Google Analytics if on a test system
const testsites = ["localhost", "stage", "uat", "pre-prod"];
if (testsites.some((testsite) => {
                        return window.location.hostname.toLowerCase().includes(testsite.toLowerCase());
                    }) == false) {
    ReactGA.initialize("G-8ZDDZ93R1X");
}

export default function App() {

    
    return (
        <AppDataContextProvider>
            <Helmet>
                <title>Bid Next Door</title>
                <meta
                    name="description"
                    content="Find Treasures in your Neighborhood"
                />
                <meta
                    name="keywords"
                    content="Auction, Estate Sale"
                />
            </Helmet>
            <Switch>
                <Route exact path='/Invoice/:invoiceId/:authkey?' render={(props) => <Invoice print="1" {...props} />} />
                <Layout>
                    <Switch>
                        {/*<Route exact path='/stripe' component={Stripe} />*/}
                        {/*<Route exact path='/stripestatus' component={Stripe}  />*/}

                        <Route exact path='/privacy' component={Privacy} />
                        <Route exact path='/error' component={Error} />
                        <Route exact path='/notfound' component={NotFound} />

                        <Route exact path='/search' component={Search} />

                        <Route exact path='/Auction/:auctionId/:optionalTitle' component={Auction} />
                        <Route exact path='/Auction/:auctionId' component={Auction} />

                        <Route exact path='/Auction/:auctionId/Lot/:lotId/:optionalTitle' component={Lot} />
                        <Route exact path='/Auction/:auctionId/Lot/:lotId' component={Lot} />

                        <Route path='/dashboard'>
                            <Switch>
                                <DashboardLayout>
                                    <Route exact path='/dashboard'><Favorites tab='favorites' /></Route>
                                    <Route exact path='/dashboard/pastfavorites' ><Favorites tab='pastfavorites' /></Route>
                                    <Route exact path='/dashboard/currentbids' ><Favorites tab='currentbids' /></Route>
                                    <Route exact path='/dashboard/pastitems' ><Favorites tab='pastitems' /></Route>
                                    <Route exact path='/dashboard/invoices' component={Invoices}></Route>
                                    <Route exact path='/dashboard/search' component={Searches} ></Route>
                                    <Route exact path='/dashboard/auctioneers' component={Auctioneers} />
                                    <Route exact path='/dashboard/invoice/:invoiceId/:schedule?' component={Invoice} />                                
                                </DashboardLayout>
                            </Switch>
                        </Route>

                        <Route path='/account'>
                            <AccountLayout>
                            
                                <Switch>
                                    <Route exact path='/account' component={Dashboard} />

                                    <BiddingHistoryLayout path='/account/bids'>
                                        <Route exact path='/account/bids/currentbids'><Favorites tab='currentbids' isMyAccount={true} /></Route>
                                        <Route exact path='/account/bids/pastbids'><Favorites tab='pastbids' isMyAccount={true} /></Route>
                                    </BiddingHistoryLayout>

                                    <Route exact path='/account/personalinfo' component={PersonalInfo} />
                                    <Route exact path='/account/notifications' component={Notifications} />
                                    <Route exact path='/account/payment' component={Payment} />
                                    <Route exact path='/account/taxcerts' component={TaxCerts} />
                                    <Route exact path='/account/logout' component={Logout} />
                                    <Route>
                                        <Redirect to="/notfound" />
                                    </Route>
                                </Switch>
                            </AccountLayout>

                        </Route>

                        <Route exact path='/seller/:sellerId' render={(props) => <Seller tab="current" {...props} />} />
                        <Route exact path='/seller/:sellerId/past' render={(props) => <Seller tab="past" {...props} />} />
                        <Route exact path='/seller/:sellerId/directors' render={(props) => <Seller tab="directors" {...props} />} />

                        <Route exact path='/director/:directorId' render={(props) => <Director tab="directorCurrent" {...props} />} />
                        <Route exact path='/director/:directorId/past' render={(props) => <Director tab="directorPast" {...props} />} />

                        <Route exact path='/' component={Home} />

                        <Route exact path='/verify/:verifyCode/:secureBidderUserId' component={VerifyEmail} />
                        <Route exact path='/resetpassword/:resetCode' component={ResetPassword} />

                        <Route exact path='/sell' component={Sell} />
                        <Route exact path='/about' component={About} />
                        <Route exact path='/terms' component={Terms} />
                        <Route exact path='/contact' component={Contact} />
                        <Route exact path='/faq' component={FAQ} />

                        <Route component={NotFound} />

                    </Switch>

                   
                </Layout>
            </Switch>
        </AppDataContextProvider>
    );

}


 